export default __webpack_public_path__ + "static/media/logo512.af4a58e2.png";